import { atom } from '@reatom/framework'

import { Platform } from '@root/entities/platform'
import { openSearchModalEvent } from '@root/features/services/search-pair'

export const searchQueryPlatformAtom = atom<Platform.Platform | undefined>(
  Platform.Terminal,
  'searchQueryPlatformAtom',
)

export const searchModalOpenAtom = atom<boolean>(false, 'searchModalOpenAtom')
openSearchModalEvent.onCall((ctx) => searchModalOpenAtom(ctx, true))
